import { DialogPopupProps } from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
import RootStore  from 'mobx-stores/root-store'
import { AlertType } from 'react-alert'
import { Api, User } from 'services'
import { Alert } from './general-store.types'
import { initialAlertPayload } from './general-store.utils'

export class GeneralStore {
  private rootStore: any
  public api: Api

  constructor(rootStore:any) {
    this.rootStore = rootStore
    this.api = new Api(this)
    makeAutoObservable(this)
  }

  // ALERT
  public alert: Alert = initialAlertPayload

  public handleApiError = error => {
    if(this.alert.counter >= 1) return; // Prevent multiple popups
    try {
      const err = JSON.parse(error.message)
      if (err.status && err.status === 401) {
        User.deauthenticate()
        this.rootStore.routingStore.replace('/')
        this.clearStores()
      // } else {
      //   if(!!err?.errors?.length) {
      //     err.errors.forEach(error => {
      //       this.showError(error?.defaultMessage || 'Something went wrong');
      //     })
      //     return;
      //   }
        this.showError(err.message || 'Something went wrong')
      }else{
        this.showError(err.message || 'Something went wrong')
      }
    } catch (runError) {
      console.error('RUN ERROR', runError)
      this.showError('Failed to fetch')
    }
  }

  private setAlert = (alert: Alert): void => {
    this.alert = alert
  }

  private showAlert = (type: AlertType, message: string): void => {
    this.setAlert({
      type,
      message,
      counter: this.alert.counter + 1
    })
  }

  public showError = (message: string): void => {
    this.showAlert('error', message)
  }

  public showInfo = (message: string): void => {
    this.showAlert('info', message)
  }

  public showSuccess = (message: string): void => {
    this.showAlert('success', message)
  }

  // LOADING
  public loading: boolean = false

  private changeLoadingValue = (values: boolean) => {
    this.loading = values
  }

  public setLoadingOn = (): void => {
    this.changeLoadingValue(true)
  }

  public setLoadingOff = (): void => {
    this.changeLoadingValue(false)
  }

  // DIALOG POPUP
  public dialogPopupProps: Partial<DialogPopupProps> = null

  public openDialogPopup = (props: Partial<DialogPopupProps>): void => {
    this.dialogPopupProps = props
  }

  public closeDialogPopup = (): void => {
    this.dialogPopupProps = null
  }

  // METHODS
  private clearStore = (): void => {
    this.setAlert(initialAlertPayload)
    this.changeLoadingValue(false)
    this.closeDialogPopup()
  }

  private clearStores = (): void => {
    this.clearStore()
    // TODO: Call every store clearStore method here
  }
}
